import { gql } from '@apollo/client';
import { ARTICLE_CARD_FIELDS } from '../../TerritoryArticlesSection/queries/articleCardDataFragment';

export const getArticleRepliesQuery = gql`
  ${ARTICLE_CARD_FIELDS}
  query getArticleRepliesQuery($articleId: ID!, $take: Int!, $skip: Int!, $type: ArticleTypeType!) {
    article(where: { id: $articleId }) {
      childArticlesCount(where: { status: { equals: "published" }, isValid: { equals: true } })
      sortedChildArticles(take: $take, skip: $skip) {
        childArticles(
          where: { status: { equals: "published" }, deactivated: { equals: false }, type: { equals: $type } }
        ) {
          ...ArticleCardFields
        }
      }
    }
  }
`;
